import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export default function ChatbotMessageContent({ className = "", content = "", role }) {
  const classes = [className, role === "assistant" ? "chatbot-markdown" : ""].filter(Boolean).join(" ");

  if (role !== "assistant") {
    return (
      <div className={classes} style={{ whiteSpace: "pre-wrap" }}>
        {content}
      </div>
    );
  }

  return (
    <div className={classes}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ href, children }) => (
            <a href={href} target="_blank" rel="noreferrer">
              {children}
            </a>
          )
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
